var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWebcam = function SvgIconWebcam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 9.75a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0m13.5 0A7.75 7.75 0 0 1 13 17.436V18.5h8a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h8v-1.064A7.751 7.751 0 0 1 12 2a7.75 7.75 0 0 1 7.75 7.75m-9.375 0a1.625 1.625 0 1 1 3.25 0 1.625 1.625 0 0 1-3.25 0M12 6.125a3.625 3.625 0 1 0 0 7.25 3.625 3.625 0 0 0 0-7.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconWebcam;